<div>
  <div class="row" *ngIf="!digitalPlansView; else digitalPlansView">
    <div class="col-9 col-md-5 n-padding-r m-t-lg">
      <p class="icon-text">
        <i class="fa fa-check margin-icon def"></i
        >{{ focusedDetails?.plansFromCart?.planOfferName }}
      </p>
      <p class="small radio-check-spacer m-t-xs">
        {{ focusedDetails?.plansFromCart?.planDescription }}
      </p>
      <p class="small radio-check-spacer m-t-lg" *ngIf="!isExistingLine">
        {{ aemContent?.dueTodayFund }}
      </p>
    </div>
    <div class="col-3 col-md-2 text-end m-t-lg" *ngIf="focusedDetails?.plansFromCart?.salesPrice">
      <p class="lead">
        {{ focusedDetails?.plansFromCart?.salesPrice | currency: 'USD' : 'symbol' }}
      </p>
      <p class="xsmall m-t-xs">{{ aemContent?.perMonth }}</p>
    </div>
    <div class="col-3 col-md-2 text-end m-t-lg" *ngIf="!focusedDetails?.plansFromCart?.salesPrice">
      <p class="lead">
        {{ focusedDetails?.plansFromCart?.displayPrice | currency: 'USD' : 'symbol' }}
      </p>
    </div>
  </div>
  <ng-template #digitalPlansView>
    <div class="row">
      <div class="col-12">
        <div class="col-9 col-md-5 p-l-0 m-t-lg">
          <p class="plan-description">{{ focusedDetails?.plansFromCart?.planOfferName }}</p>
        </div>
        <div
          class="col-9 col-md-5 p-l-0 m-t-sm m-b-lg"
          *ngIf="focusedDetails?.plansFromCart?.salesPrice"
        >
          <p class="leadDigital">
            {{ focusedDetails?.plansFromCart?.salesPrice | currency: 'USD' : 'symbol' }}/
            {{ aemContent?.dueMonthly }}
          </p>
        </div>
        <div
          class="col-9 col-md-5 p-l-0 m-t-sm m-b-lg"
          *ngIf="!focusedDetails?.plansFromCart?.salesPrice"
        >
          <p class="leadDigital">
            {{ focusedDetails?.plansFromCart?.displayPrice | currency: 'USD' : 'symbol' }}/
            {{ aemContent?.dueMonthly }}
          </p>
        </div>
      </div>
    </div>
    <div class="row m-t-xl" *ngIf="isExistingLine">
      <div class="col-12">
        <hr class="divider" />
      </div>
    </div>
  </ng-template>
  <div class="row m-t-xl" *ngIf="isExistingLine">
    <div class="col-12">
      <hr class="divider" />
    </div>
  </div>
</div>
